import { List, Map } from "immutable"
import * as React from "react"
import { ApiResult } from "../../../Shared/api/apiTypes"
import { Html } from "../../../Shared/backendApi/Text"
import { Notice } from "../../../Shared/components/Notice"
import { errorText, getActivityEditions, getDatesForPeriod, loadingText, Region } from "../../custom_api/api"
import { ActivityEditionN } from "../../custom_models/activity_edition"
import { emptyOpt, makeOpt } from "../../custom_utils/option"
import { ActivityEditionList } from "../components/activity_edition_list"
import { Block as BuildingBlock, BlockRenderer } from "../components/block_renderer"
import { Jumbo } from "../components/jumbo"
import { Block } from "../components/library/container"
import { BasePageProps } from "../components/page_renderer"
import { PeriodSlug, RegionAndDateFilter } from "../components/region_and_date_filter"
import { SearchBarWrapper } from "../components/search_bar"

export interface ActivityDetailPageProps extends BasePageProps {
  readonly kind: "activityDetail"
  readonly activityId: number
  readonly pageTitle: string
  readonly headerTitle: string
  readonly subtitle: string
  readonly description: string
  readonly imageUrl: string
  readonly imageUrlLarge: string
  readonly phImageUrlSmall?: string
  readonly phImageUrl: string
  readonly phImageUrlLarge: string
  readonly imageAlt: string
  readonly noticeTitle: string
  readonly noticeContents: string
  readonly regions: Map<string, Region>
  readonly selectedPeriod: PeriodSlug
  readonly selectedRegion: string
  readonly selectPeriod: (e: React.ChangeEvent<HTMLSelectElement>) => void
  readonly selectRegion: (e: React.ChangeEvent<HTMLSelectElement>) => void
  readonly blocks: List<BuildingBlock>
}

interface ActivityDetailPageState {
  readonly editions: ApiResult<List<ActivityEditionN>>
}

const activityDetailPageStateZero: ActivityDetailPageState = {
  editions: "loading",
}

export class ActivityDetailPage extends React.Component<ActivityDetailPageProps, ActivityDetailPageState> {
  constructor(props: ActivityDetailPageProps) {
    super(props)

    this.state = activityDetailPageStateZero

    document.title = this.props.pageTitle
  }

  componentDidMount() {
    const p = this.props
    const s = this.state

    if (s.editions == "loading") {
      getActivityEditions({
        cluster: emptyOpt(),
        activity: makeOpt(q => q.Where(a => a.Id.Equals(p.activityId).And(a.HideInOverview.Equals(false)))),
        edition: emptyOpt(),
        region: makeOpt(q => 
          p.selectedRegion 
            ? q.Where(r => r.Slug.Equals(p.selectedRegion)) 
            : q  
        ),
        location: emptyOpt(),
        event: makeOpt(q =>
          q.Where(e => {
            let period = getDatesForPeriod(p.selectedPeriod)
            var startDate = period.start.toDate()
            var utcStartDate = new Date(startDate.getTime() + startDate.getTimezoneOffset() * 60000)
            return e.Date.IsAfter(utcStartDate).And(e.Date.IsBefore(period.end.toDate()))
          })
        )
      }).then(x => this.setState(s => ({ ...s, editions: x })))
    }
  }

  componentWillReceiveProps(nextProps: ActivityDetailPageProps) {
    const p = this.props
    const np = nextProps

    if (p.selectedPeriod == np.selectedPeriod && p.selectedRegion == np.selectedRegion) return

    this.setState(
      (s, _) => ({ ...s, clusters: "loading" }),
      () => {
        getActivityEditions({
          cluster: emptyOpt(),
          activity: makeOpt(q => q.Where(a => a.Id.Equals(np.activityId).And(a.HideInOverview.Equals(false)))),
          edition: emptyOpt(),
          region: makeOpt(q => 
            np.selectedRegion 
              ? q.Where(r => r.Slug.Equals(np.selectedRegion)) 
              : q  
          ),
          location: emptyOpt(),
          event: makeOpt(q =>
            q.Where(e => {
              let period = getDatesForPeriod(np.selectedPeriod)
              
              var startDate = period.start.toDate()
              var utcStartDate = new Date(startDate.getTime() + startDate.getTimezoneOffset() * 60000)
              return e.Date.IsAfter(utcStartDate).And(e.Date.IsBefore(period.end.toDate()))
            })
          )
        }).then(x => this.setState(s => ({ ...s, editions: x })))
      }
    )
  }

  render() {
    const p = this.props
    const s = this.state

    const editionsList: JSX.Element = (
      <div className="container--mg align--center" aria-live="polite">
        {s.editions == "loading" ? (
          <div className="text--styled">
            <p className="weight--bold container--s">{loadingText}</p>
          </div>
        ) : s.editions == "error" ? (
            <div className="text--styled">
              <p className="weight--bold container--s">{errorText}</p>
            </div>
        ) : (
          <ActivityEditionList regions={p.regions} editions={s.editions} />
        )}
      </div>
    )

    const filter: JSX.Element = (
      <SearchBarWrapper>
        <RegionAndDateFilter
          enabled={s.editions != "loading" && s.editions != "error"}
          selectedPeriod={p.selectedPeriod}
          selectedRegion={p.selectedRegion}
          selectPeriod={p.selectPeriod}
          selectRegion={p.selectRegion}
          regions={p.regions}
        />
      </SearchBarWrapper>
    )

    return (
      <div>
        <Jumbo
          title={p.headerTitle}
          contents={p.description}
          imageUrl={p.phImageUrl}
          imageUrlLarge={p.phImageUrlLarge}
          imageAlt={p.imageAlt}
          size="small"
          kind="activity"
        />
        {filter}
        <Block>{editionsList}</Block>
        <hr />
        <Block>
          <div className="container--mg align--center">
            <Notice title={p.noticeTitle} description={Html(p.noticeContents)} />
          </div>
          <hr />
          <BlockRenderer blocks={p.blocks} />
        </Block>
      </div>
    )
  }
}

{/* TH: Added to styleguide! */}
